"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../../types/General");
const buildCallableAudioStackPush = (args) => async ({ functionId, entryVars: { [General_1.DEFINITION_PROP_NAMES.URL]: uri, }, callbacks, executeProcesses, }) => {
    if (!(0, ts_validators_1.valueIsString)(uri) || uri === '') {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], `Invalid uri: ${uri}`);
        return;
    }
    await args.pushAudio(uri)
        .then(() => {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.THEN]);
    })
        .catch((error) => {
        executeProcesses(functionId, callbacks[General_1.DEFINITION_PROP_NAMES.CATCH], `${error}`);
    });
};
exports.default = buildCallableAudioStackPush;
